<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-07-04 15:56:36
 * @LastEditors: Sephiroth·D·Kid
 * @LastEditTime: 2019-08-26 15:05:31
 * @Description: 标的详情
 -->
<template>
  <div class="project-detail-wrapper">
    <div class="header-wrapper">
      <h3 class="name">{{ baseInfo.name }}</h3>
      <div class="content-wrapper">
        <div class="left">
          <div class="base-info">
            <div class="item">
              <h4 class="label">项目金额</h4>
              <p class="text">
                <span class="money">{{ baseInfo.money }}</span>
                <i>元</i>
              </p>
            </div>
            <div class="item">
              <h4 class="label">约定年化借款利率</h4>
              <p class="text">
                <span class="rate">{{ baseInfo.annualRate }}</span>
                <i>%</i>
              </p>
            </div>
            <div class="item">
              <h4 class="label">项目期限</h4>
              <p class="text">
                <span class="month">{{ baseInfo.period }}</span>
                <i>个月</i>
              </p>
            </div>
          </div>
          <div class="detail">
            <el-row class="detail-row">
              <el-col :span="10">
                <span class="label">借款编号</span>
                <span class="text">{{ baseInfo.code }}</span>
              </el-col>
              <el-col :span="14">
                <span class="label">发标日期</span>
                <span class="text">{{ baseInfo.createTime }}</span>
              </el-col>
            </el-row>
            <el-row class="detail-row">
              <el-col :span="10">
                <span class="label">收益方式</span>
                <span class="text">{{ baseInfo.repayWay }}</span>
              </el-col>
              <el-col :span="14">
                <span class="label">起息日</span>
                <span class="text">{{ baseInfo.interestAccrual }}</span>
              </el-col>
            </el-row>
            <el-row class="detail-row">
              <el-col :span="10">
                <span class="label">退出机制</span>
                <span class="text">不可提前退出</span>
              </el-col>
              <el-col :span="14" class="progress-box">
                <span class="label">项目进度</span>
                <div class="progress-bar">
                  <div class="bar" ref="progressBar" v-if="baseInfo.progress < 1">
                    <div class="bar-in" :style="{ width: `${baseInfo.progress * 100}%` }"></div>
                  </div>
                  <p class="percent-text" v-if="baseInfo.progress < 1">
                    {{ `${baseInfo.progress ? baseInfo.progress * 100 : 0}%` }}
                  </p>
                </div>
              </el-col>
            </el-row>
            <el-row class="detail-row contract">
              <p>
                市场有风险，出借需谨慎，详情请查看
                <router-link to="/perfect-select/risk-tips" class="link">
                  《风险提示书》
                </router-link>
                <router-link to="/perfect-select/agreement" class="link">
                  《借款协议》
                </router-link>
              </p>
            </el-row>
          </div>
        </div>
        <div class="right is-full" v-if="baseInfo.progress >= 1">
          <img src="https://files.jinr.com/jinr-index/img/bid-full.png" alt="" srcset="" />
          <p class="text">
            <span class="item">
              <b class="label">满标用时：</b>
              <i>{{ baseInfo.costTime }}天</i>
            </span>
            <span class="item">
              <b class="label">出借笔数：</b>
              <i class="num">{{ lendNum }}</i>
              <i>笔</i>
            </span>
          </p>
          <div class="btn" @click="handleBack">关注其他项目</div>
        </div>
        <div class="right not-full" v-else>
          <p class="remain-money">剩余金额：{{ baseInfo.remainMoney }}</p>
          <div class="btn">{{ baseInfo.createTime }}</div>
          <p class="tips">很快就能在PC端购买啦，敬请期待~</p>
        </div>
      </div>
    </div>
    <div class="more-detail-wrapper">
      <ul class="tab-wrapper">
        <li
          class="tab-item"
          v-for="(item, index) in tabList"
          :key="index"
          :class="{ active: activeIndex === index }"
          @click="tabChange(index)"
        >
          {{ item.label }}
        </li>
      </ul>
      <div class="content">
        <component :is="componentId.component" :propsData="componentId.props"></component>
      </div>
    </div>
  </div>
</template>
<script>
import BaseData from './components/base-data.vue';
import LendRecord from './components/lend-record.vue';
import CheckRecord from './components/check-record.vue';
import RefundPlan from './components/refund-plan.vue';
export default {
  name: 'project-detail',
  components: {
    BaseData,
    LendRecord,
    CheckRecord,
    RefundPlan
  },
  data() {
    return {
      activeIndex: 0,
      lendNum: 0,
      tabList: [
        {
          label: '项目详情'
        },
        {
          label: '出借记录'
        },
        {
          label: '审核记录'
        },
        {
          label: '还款计划'
        }
      ],
      userType: {
        '0': '平台',
        '1': '自然人',
        '2': '法人'
      },
      baseInfo: {},
      userInfo: {},
      componentList: [
        {
          name: 'base-data',
          component: BaseData,
          props: {
            baseInfo: {}
          }
        },
        {
          name: 'lend-record',
          component: LendRecord,
          props: {}
        },
        {
          name: 'check-record',
          component: CheckRecord,
          props: {}
        },
        {
          name: 'refund-plan',
          component: RefundPlan,
          props: {}
        }
      ]
    };
  },
  computed: {
    componentId() {
      return this.componentList[this.activeIndex];
    }
  },
  created() {
    // console.log(this.$route.params);
    if (this.$route.params.flag === '1') {
      this.requestDetail();
      this.requestRecords();
      this.requestPlan();
    } else {
      this.requestNo1Detail();
      return;
    }
  },
  methods: {
    async requestDetail() {
      const res = await this.$http.post('cg/commonRequest', {
        method: 'project.pc.detail',
        projectid: this.$route.params.id
        // flag: this.$route.params.flag
      });
      if (res.code === 200) {
        const data = res.data;
        this.baseInfo = {
          name: data.project_name,
          code: data.project_code,
          money: data.moneys,
          remainMoney: data.redius_money,
          currentMoney: parseFloat(data.moneys - data.redius_moneys).toFixed(2),
          progress: parseFloat((data.moneys - data.redius_moneys) / data.moneys).toFixed(2),
          projectDetail: data.desc.projectDetail,
          period: data.period,
          annualRate: data.annual_rate,
          interestAccrual: data.interest_accrual,
          repayWay: data.repay_way,
          createTime: data.c_time,
          costTime: Math.ceil(
            (new Date(data.full_time.replace(/-/g, '/')).getTime() -
              new Date(data.sell_time.replace(/-/g, '/')).getTime()) /
              24 /
              3600000
          ) // 满标用时
        };
        this.userInfo = {
          ...data.debtInfo,
          userName: data.desc.projectUser.username,
          sex: data.desc.projectUser.sex,
          identityId: data.desc.projectUser.identityid,
          usage: data.usage,
          userType: this.userType[`${data.desc.projectUser.user_type}`],
          industry: data.desc.projectUser.industry,
          income: data.desc.projectUser.income,
          overdueInSixMonth: data.debtInfo.creditReporting.substr(4, 3),
          hasOverdue: '未逾期'
        };
        this.componentList[0].props = {
          baseInfo: {
            ...this.baseInfo,
            isGuarantee: data.is_guarantee === 1 ? '是' : '否'
          },
          userInfo: { ...this.userInfo }
        };
        this.componentList[1].props['baseInfo'] = { ...this.baseInfo };
        this.componentList[2].props['checkList'] = data.loanDta;
        // console.log(this.componentList[0]);
      }
    },
    async requestRecords() {
      const res = await this.$http.post('cg/commonRequest', {
        method: 'project.invest.user',
        projectid: this.$route.params.id
      });
      if (res.code === 200) {
        this.lendNum = res.data.list ? res.data.list.length : 0;
        this.componentList[1].props['recordList'] = res.data.list.map(item => {
          return {
            lender: item.mobile,
            money: item.invest_money,
            date: item.invest_time
          };
        });
        console.log(this.componentList[1].props['recordList']);
      }
      // console.log(res);
    },
    async requestPlan() {
      const res = await this.$http.post('cg/commonRequest', {
        method: 'project.pc.plan',
        projectid: this.$route.params.id
      });
      if (res.code === 200) {
        let totalRest = 0;
        res.data.forEach(item => {
          totalRest += parseFloat(item.principal);
        });
        this.componentList[3].props['refundPlan'] = res.data.map(item => {
          return {
            period: item.period,
            interestOfPrincipal: item.need_money,
            principal: item.principal,
            interests: item.interest,
            rest: parseFloat(
              totalRest - item.principal <= 0 ? 0 : (totalRest -= item.principal)
            ).toFixed(2),
            date: item.need_time.split(' ')[0]
          };
        });
      }
    },
    async requestNo1Detail() {
      const res = await this.$http.post('/cg/commonRequest', {
        method: 'oproject.detail',
        projectid: this.$route.params.id
      });
      if (res.code === 200) {
        const data = res.data;
        console.log(data.detail);
        this.baseInfo = {
          name: data.detail.project_name,
          code: data.applyRecord.contract_no,
          money: data.detail.finance_money,
          remainMoney: data.detail.dropTankMoney,
          progress: parseFloat(data.detail.invested_money / data.detail.finance_money).toFixed(4),
          projectDetail: data.detail.description,
          period: data.detail.project_period,
          annualRate: data.detail.rate_init,
          interestAccrual: data.detail.interest_accrual,
          repayWay: data.detail.repay_way,
          createTime: data.detail.c_time,
          costTime: data.full.fullNum
        };
        console.log(this.baseInfo.progress);
        this.lendNum = data.investList.length;
        this.userInfo = {
          ...data.debtInfo,
          userName: data.applyRecord.base_info.base_realName,
          sex: data.applyRecord.base_info.base_sex === 1 ? '男' : '女',
          identityId: data.applyRecord.base_info.base_identityid,
          usage: data.applyRecord.base_info.base_usage,
          userType: this.userType[`${data.applyRecord.base_info.user_type}`],
          industry: data.detail.industry,
          income: data.applyRecord.base_info.income,
          // overdueInSixMonth: data.applyRecord.creditReporting.substr(4, 3),
          overdueInSixMonth: data.applyRecord.creditReporting,
          hasOverdue: '未逾期'
        };
        this.componentList[0].props = {
          baseInfo: {
            ...this.baseInfo,
            isGuarantee: data.is_guarantee === 1 ? '是' : '否'
          },
          userInfo: { ...this.userInfo }
        };
        this.componentList[1].props['recordList'] = data.investList.map(item => {
          // console.log(item);
          return {
            lender: item.mobile,
            money: item.invest_money,
            date: item.invest_time
          };
        });
        this.componentList[1].props['baseInfo'] = { ...this.baseInfo };
        this.componentList[2].props['checkList'] = data.applyRecord.audit_pic;
        this.componentList[3].props['refundPlan'] = data.returnedList.map(item => {
          return {
            period: item.period,
            interestOfPrincipal: item.need_money,
            principal: item.principal,
            interests: item.interest,
            rest: item.surplus_principal,
            date: item.need_time
          };
        });
      }
    },
    handleBack() {
      // this.$router.push('/perfect-select/project-list');
      this.$router.go(-1);
    },
    tabChange(index) {
      this.activeIndex = index;
    }
  }
};
</script>
<style lang="less" scoped>
.project-detail-wrapper {
  .header-wrapper {
    min-height: 388px;
    overflow: hidden;
    background: #fff;
    width: 1200px;
    margin: 50px auto 37px;
    border-radius: 20px;
    .name {
      height: 60px;
      border-bottom: 1px solid #e7e7e7;
      line-height: 60px;
      padding-left: 30px;
      box-sizing: border-box;
      font-size: 20px;
    }
    .content-wrapper {
      display: flex;
      justify-content: space-between;
      // height: 324px;
      .base-info {
        display: flex;
        justify-content: flex-start;
        .item {
          width: 240px;
          .label {
            color: #676767;
            line-height: 36px;
            font-size: 16px;
            margin-bottom: 20px;
          }
          .text {
            line-height: 36px;
            span {
              font-size: 32px;
              color: #333;
              margin-right: 12px;
            }
            i {
              font-size: 16px;
              color: #333;
            }
            .money {
              color: #257af1;
            }
          }
        }
      }
      .detail {
        margin-top: 44px;
        font-size: 14px;
        .detail-row {
          margin-bottom: 18px;
        }
        .contract {
          color: #6a6a6a;
          line-height: 40px;
          .link {
            color: #247af1;
          }
        }
        .label {
          display: inline-block;
          width: 60px;
          margin: 0 40px 0 0;
        }
        .text {
          color: #999;
        }
        .progress-box {
          display: flex;
          .label {
            margin-right: 40px;
            color: #ff5902;
          }
        }
        .progress-bar {
          width: 300px;
          height: 16px;
          position: relative;
          background: #e5e5e5;
          border-radius: 8px;
          .bar {
            width: 100%;
            height: 100%;
            position: absolute;
            overflow: hidden;
            border-radius: 8px;
            .bar-in {
              height: 100%;
              background: #ff5902;
            }
          }
          .percent-text {
            position: absolute;
            top: 20px;
            left: 0;
            font-family: 'PingFangSC-Regular';
            font-size: 14px;
            color: #ff5902;
            text-align: center;
          }
        }
      }
      .left {
        padding: 34px 0 20px 50px;
      }
      .right {
        display: flex;
        width: 414px;
        // height: 100%;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        // padding-bottom: 45px;
        // box-sizing: border-box;
        border-left: 1px solid #f2f2f2;
      }
      .is-full {
        img {
          width: 144px;
        }
        .text {
          font-family: 'PingFangSC-Regular';
          font-size: 14px;
          margin: 34px 0;
          .item {
            margin: 0 10px;
          }
          .label {
            color: #6a6a6a;
          }
          i {
            font-family: 'PingFangSC-Thin';
            color: #6a6a6a;
          }
          .num {
            color: #fa811d;
          }
        }
        .btn {
          width: 154px;
          height: 40px;
          text-align: center;
          line-height: 40px;
          background: #247af1;
          color: #fff;
          border-radius: 6px;
          cursor: pointer;
        }
      }
      .not-full {
        p {
          font-size: 14px;
          color: #666;
        }
        .remain-money {
          text-align: left;
          font-size: 16px;
        }
        .btn {
          width: 240px;
          margin: 20px 0;
          text-align: center;
          padding: 16px 20px;
          line-height: 1;
          font-size: 16px;
          border-radius: 4px;
          color: #fff;
          background: #9fcfff;
          cursor: not-allowed;
        }
      }
    }
  }
  .more-detail-wrapper {
    overflow: hidden;
    background: #fff;
    width: 1200px;
    min-height: 300px;
    margin: 0 auto;
    border-radius: 20px;
    .tab-wrapper {
      height: 60px;
      border-bottom: 1px solid #f2f2f2;
      display: flex;
      .tab-item {
        margin: 0 20px;
        padding: 0 50px;
        line-height: 60px;
        font-family: 'PingFangSC-Regular';
        font-size: 16px;
        color: #333333;
        cursor: pointer;
      }
      .tab-item.active {
        color: #247af1;
      }
    }
  }
}
</style>
